module.exports = __webpack_public_path__ + "static/img/left_brd.38e1edfc.png";